import makeApiCall from "./master/axiosIndex";

export const commentsApis = {
  fetchCommentsByProject: (projectId: string | number): Promise<any> =>
    makeApiCall({
      url: `/comments/project/${projectId}`,
      method: "get",
    }),
  fetchCommentsByTask: (taskId: string | number): Promise<any> =>
    makeApiCall({
      url: `/comments/task/${taskId}`,
      method: "get",
    }),
  fetchCommentsByIssue: (issueId: string | number): Promise<any> =>
    makeApiCall({
      url: `/comments/issue/${issueId}`,
      method: "get",
    }),
  editComment: (commentId: number, content: string): Promise<any> =>
    makeApiCall({
      url: `/comments/edit`,
      method: "put",
      data: {
        commentId,
        content,
      },
    }),
  deleteComment: (commentId: number): Promise<any> =>
    makeApiCall({
      url: `/comments/delete/${commentId}`,
      method: "delete",
    }),
};
